import { render } from "./EmploymentPeriodsTable.vue?vue&type=template&id=d8a09cd2&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=d8a09cd2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8a09cd2"]])

export default __exports__